/**
 * This file was auto-generated by scripts/generate-api-constants.ts.
 * Do not make direct changes to the file.
 */

/** Maximum request body size accepted by the API (BodySizeLimitMiddleware in app/main.py). */
export const MAX_UPLOAD_BYTES = 52428800;
